const config = {
    build_number: '615572',
    build_timestamp: '2026-08-25T17:38:00.788Z',
    build_commit: '0437c092ef7626baf05ff3935fff1b6b219e5013',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
